import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '../../../shared/button/components/button';
import PageHeader from '../../../shared/page-header/components/page-header';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import Helpers from '../../../../common/helpers';
import { toggleConvertUserModal } from '../actions/clients-actions';

import '../styles/convert-user-modal.css';

class ConvertUserModal extends Component {
  closeModal() {
    const { toggleConvertUserModal } = this.props;

    toggleConvertUserModal(false, null);
  }

  goToMarketingMaterialPage() {
    this.closeModal();
    Helpers.goToPage('/app/banners');
  }

  render() {
    const { t } = this.context;
    const { showConvertUserModal } = this.props;

    return (
      <Modal visible={showConvertUserModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="default-modal convert-user-modal-container">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <div className="text-center">
            <PageHeader title={'CLIENTS.CONVERT_MODAL_TITLE'} />
          </div>
          <div className="text-center">
            <p className="default-label">{t('CLIENTS.CONVERT_MODAL_FIRST_SENTENCE')}</p>
          </div>
          <div className="text-center">
            <p className="default-label">{t('CLIENTS.CONVERT_MODAL_SECOND_SENTENCE')}</p>
          </div>
          <div className="row">
            <div className="col-sm-12 m-b-20">
              <Button label={'CLIENTS.CHECK_MARKETING_MATERIAL'} customClass={`affiliate-btn-red m-t-20`} onClick={() => this.goToMarketingMaterialPage()} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Button label={'COMMON.CLOSE'} onClick={() => this.closeModal()} />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showConvertUserModal: state.clientsReducer.showConvertUserModal,
});

const mapDispatchToProps = dispatch => ({
  toggleConvertUserModal: show => {
    dispatch(toggleConvertUserModal(show));
  },
});

ConvertUserModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvertUserModal);



// WEBPACK FOOTER //
// ./src/app/main/clients/components/convert-user-modal.js